import React, { useState, useEffect } from 'react';

import { Row, Col } from "react-bootstrap";

// Import app configuration for company details
import { appConfig } from '../config/app.js';

const SuccessDisplay = ({ sessionId }) => {
  return (
    <div className="mt-5">      
        <div className="row mx-0">                        
            <div className="col-1"></div>
            <div className="col-10">
                <Row className="primary-font-color" style={{ paddingTop: "50px", overflow:"hidden" }}>
                    <Col xs={12} >       
                            
                        <Row style={{ paddingTop: "20px" }}>
                            <Col>THANKS FOR SUBSCRIBING!</Col>
                        </Row>     
                        <Row style={{fontSize:"0.9rem"}}>
                            <div className="col-12 mt-4">
                                To make changes to your subscription, please go to your settings.
                                <br /><br />If you run into any issues or just want to share some feedback, please email {appConfig.contact?.primary?.name || 'our support team'} at {appConfig.contact?.primary?.email || 'support@company.com'}.
                                <br /><br />
                            </div>
                        </Row>
                        <Row>                            
                            <Col xs={3}>
                                <a href={'/dashboard'}>
                                    <button type="button" className="btn btn-block btn-outline-success" style={{color:"#067100", backgroundColor:"#ffffff", fontSize:"0.9rem"}}>Done</button>
                                </a>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        </div>
    </div>    
  );
};

const Message = ({ message }) => {
    return (

    <div className="mt-5">      
        <div className="row mx-0">                        
            <div className="col-1"></div>
            <div className="col-10">
                <Row style={{ paddingTop: "20px", overflow:"hidden" }}>
                    <Col xs={12} >       
                            
                        <Row style={{ paddingTop: "20px", fontSize:"3em", lineHeight: "1em" }}>
                            <Col>Stripe Checkout</Col>
                        </Row>     
                        <div className="row" >
                            <div className="col-12 mt-3">
                                {message}
                                <br /><br />
                                <a href={'/dashboard'}>
                                    <button type="button" className="btn btn-lg btn-block btn-outline-success" style={{color:"#067100", backgroundColor:"#ffffff"}}>Done</button>
                                </a>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
  );
};

export default function SubscriptionConfirmation() {
  let [message, setMessage] = useState('');
  let [success, setSuccess] = useState(false);
  let [sessionId, setSessionId] = useState('');

  useEffect(() => {
    // Check to see if this is a redirect back from Checkout
    const query = new URLSearchParams(window.location.search);

    if (query.get('success')) {
      setSuccess(true);
      setSessionId(query.get('session_id'));
    }

    if (query.get('canceled')) {
      setSuccess(false);
      setMessage(
        "Order canceled - continue to use the product and try again when you're ready."
      );
    }
  }, [sessionId]);

  if (success && sessionId !== '') {
    return <SuccessDisplay sessionId={sessionId} />;
  } else {
    return <Message message={message} />;
  }
}